import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UsePostmortemInfo from "../../context/PostmortemContext";
import { PostmortemServices } from "../../services/postmortemServices";
import { Typography } from "@anchor/react-components/dist/lib/components";
import UserInfo from "../../context/UserAccessContext";
import UseTourContext from "../../context/TourContext";
import { getTourSteps } from "../../Utils/getTourSteps";
import { postmortemApiEndpoint } from "../../config";
import successNotification from "../../Components/Notification/successNotification";
import errorNotification from "../../Components/Notification/errorNotification";
// import { useWebSocket } from "../../context/WebSocketContext/WebSocketContext";
import { useMsal } from "@azure/msal-react";
import { FreeTextService } from "../../services/freeTextService";
import { useFetchWithRetry } from "../../Utils/fetchWithRetry";
import { invalidateCachedReads } from "../../Utils/queryClient";

export const UseEditPostmortems = () => {
  const {
    memoizedDispatch,
    setCurrentPostmortemObject,
    postmortemState,
    currentPostmortemObject,
    setPostmortemTeamId,
    setCollaborators,
    setPostmortemObjectForAuditing,
  } = UsePostmortemInfo();
  const { updateIncompleteStatus, updateClosedWithoutLTReviewStatus, updateEDSignOffStatus, postAuditData, generateRCAOnDemand } = PostmortemServices();
  const { accounts } = useMsal();
  const { acquireEditLock, releaseEditLock, releaseEditLockBeacon, checkEditLock } = FreeTextService();
  const { fetchWithRetry } = useFetchWithRetry();
  // const webSocketContext = useWebSocket();
  // const broadCastIncompleteStatus = webSocketContext?.broadCastIncompleteStatus;
  const broadCastIncompleteStatus = null; // WebSocket disabled
  const location = useLocation();
  const apiEndpoint = postmortemApiEndpoint;
  const [currentStep, setCurrentStep] = useState(0);
  const [postmortemIsInComplete, setPostMortemIsIncomplete] = useState(false);
  const [closedWithoutLTReview, setClosedWithoutLTReview] = useState(false);
  const [edSignedOff, setEdSignedOff] = useState(false);
  const [edName, setEdName] = useState("");
  const [vendorSignedOff, setVendorSignedOff] = useState(false);
  const [causedByVendor, setCausedByVendor] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [generatingRCA, setGeneratingRCA] = useState(false);
  const mimStateRef = useRef(null);
  const rcaPollingIntervalRef = useRef(null); // Store polling interval for cleanup
  const [error, setError] = useState(null);

  // Edit lock state
  const [editLockStatus, setEditLockStatus] = useState("checking"); // "checking" | "locked" | "acquired" | "expired" | "error"
  const [editLockedBy, setEditLockedBy] = useState("");
  const [editLockedByName, setEditLockedByName] = useState("");
  const [showLockExpiryWarning, setShowLockExpiryWarning] = useState(false);
  const [lockExpiryCountdown, setLockExpiryCountdown] = useState(
    Math.round(parseInt(process.env.REACT_APP_EDIT_LOCK_WARN_BEFORE_EXPIRY_MS || "30000", 10) / 1000)
  );
  const editLockRefreshInterval = useRef(null);
  const editLockWarningTimeout = useRef(null);  // fires 30s before expiry
  const editLockExpiryTimeout = useRef(null);   // fires at expiry
  const editLockCountdownInterval = useRef(null); // ticks the countdown
  const lockAcquiredRef = useRef(false);         // true only while THIS instance holds the lock
  const titleFlashInterval = useRef(null);       // flashing tab title interval
  const beepIntervalRef = useRef(null);          // repeating beep interval
  const audioCtxRef = useRef(null);              // shared AudioContext — close() stops all sound instantly
  const [steps, setSteps] = useState([
    {
      id: 1,
      title: (
        <mc-tooltip
          appearance="default"
          fit="auto"
          position="bottom"
          width="auto"
          dontflip
          dontshift
        >
          <div slot="trigger" style={{ paddingLeft: "40%" }}>
            New
          </div>
          <div
            style={{
              padding: "10px",
              backgroundColor: "#42B0D5",
              color: "white",
            }}
          >
            <Typography variant="h5" style={{ marginBottom: 0 }}>
              Complete Postmortem Sections
            </Typography>
            <br />
            <div style={{ display: "flex" }}>
              <div>
                <strong>Incident Summary</strong>
                <br />
                Complete{" "}
                <ul>
                  <li>Incident summary</li> <li>Preceding events</li>
                  <li>Impact</li>
                  <li>Detection</li>
                  <li>Response sections</li>
                </ul>{" "}
              </div>
              <div>
                <strong>Root Cause</strong>
                <br />
                Complete
                <ul>
                  <li>Recovery</li>
                  <li>Root Cause Identification</li>
                  <li>Root Cause</li>
                  <li>Recurrence</li>
                </ul>
              </div>
              <div>
                <strong>Preventive and Corrective Measures</strong>
                <br />
                Give Tickets for
                <ul>
                  <li>Jira</li>
                  <li>PTasks</li>
                </ul>
              </div>
            </div>
          </div>
        </mc-tooltip>
        // <OverlayTrigger
        // style={{position:"absolute", top:"20px"}}
        //   key={"bottom"}
        //   placement={"bottom"}
        //   overlay={
        //     <Tooltip style={{backgroundColor:"white", color:"black"}} id={`tooltip-bottom`}>
        //       Tooltip on <strong>Tool Tip</strong>.
        //     </Tooltip>
        //   }
        // >
        //   <div>New</div>
        // </OverlayTrigger>
      ),
    },

    {
      id: 2,
      title: (
        <mc-tooltip
          appearance="default"
          fit="auto"
          position="bottom"
          width="auto"
          dontflip
          dontshift
        >
          <div slot="trigger" style={{ paddingLeft: "30%" }}>
            In Progress
          </div>
          <div>
            <Typography
              paragraph
              style={{
                marginBottom: 0,
                padding: "10px",
                backgroundColor: "#42B0D5",
                color: "white",
              }}
            >
              This shows that current postmortem is in in-progress state
              <br />
              which essentially means that SRE and LT are not been notified for
              the review yet
              <br />
              once you have submitted the postmortem for review,
              <br />
              the status will be changed to "LEADERSHIP REVIEW" and Leadership will be
              notified for the review.
            </Typography>
          </div>
        </mc-tooltip>
      ),
    },
    {
      id: 3,
      title: (
        <mc-tooltip
          appearance="default"
          fit="auto"
          position="bottom"
          width="auto"
          dontflip
          dontshift
        >
          <div slot="trigger" style={{ paddingLeft: "30%" }}>
            <p style={{ margin: "0" }}>Initial Draft</p>
          </div>
          <div>
            <Typography
              paragraph
              style={{
                marginBottom: 0,
                padding: "10px",
                backgroundColor: "#42B0D5",
                color: "white",
              }}
            >
              If this state is checked this shows that current postmortem is in
              LEADERSHIP REVIEW state
              <br />
              which essentially means that Leadership is notified for the review
            </Typography>
          </div>
        </mc-tooltip>
      ),
    },
    {
      id: 4,
      title: (
        <mc-tooltip
          appearance="default"
          fit="auto"
          position="bottom"
          width="auto"
          dontflip
          dontshift
        >
          <div slot="trigger" style={{ paddingLeft: "30%" }}>
            <p ref={mimStateRef} style={{ margin: "0" }}>
              {" "}
              LEADERSHIP REVIEW
            </p>
          </div>
          <div>
            <Typography
              paragraph
              style={{
                marginBottom: 0,
                padding: "10px",
                backgroundColor: "#42B0D5",
                color: "white",
              }}
            >
              If this state is checked this shows that current postmortem is in
              L.T review state
              <br />
              which essentially means that L.T is notified for the review
            </Typography>
          </div>
        </mc-tooltip>
      ),
    },
    {
      id: 5,
      title: (
        <mc-tooltip
          appearance="default"
          fit="auto"
          position="bottom"
          width="auto"
          dontflip
          dontshift
        >
          <div slot="trigger" style={{ paddingLeft: "30%" }}>
            <p style={{ margin: "0" }}>L.T. Review</p>
          </div>
          <div>
            <Typography
              paragraph
              style={{
                marginBottom: 0,
                padding: "10px",
                backgroundColor: "#42B0D5",
                color: "white",
              }}
            >
              If this state is checked this shows that this postmortem has been
              reviewed by L.T and will be closed by default
              <br />
            </Typography>
          </div>
        </mc-tooltip>
      ),
    },
    {
      id: 6,
      title: (
        <mc-tooltip
          appearance="default"
          fit="auto"
          position="bottom"
          width="auto"
          dontflip
          dontshift
        >
          <div slot="trigger" style={{ paddingLeft: "30%" }}>
            <p style={{ margin: "0" }}>Done</p>
          </div>
          <div>
            <Typography
              paragraph
              style={{
                marginBottom: 0,
                padding: "10px",
                backgroundColor: "#42B0D5",
                color: "white",
              }}
            >
              If this state is checked this shows that current postmortem is
              completed and closed
              <br />
            </Typography>
          </div>
        </mc-tooltip>
      ),
    },
  ]);
  const {
    refreshTouringSteps,
    setRefreshTouringSteps,
    setCurrentTouringSteps,
  } = UseTourContext();

  const { fetchPostmortemByIdAndCollaborators } = PostmortemServices();
  const {graphData , userIsAdmin, userAccessData, userIsAMimMember, userIsApmtMember } = UserInfo();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const postmortemID = params.get("postmortemID");
  const pageType = params.get("page_type");

  const [metaData, setMetaData] = useState({
    pmtId: "",
    incidentID: "",
    problemID: "",
    priority: "",
    createdOn: "",
    cmdb_ci: "",
    assigned_to: "",
    state: "",
    owningBusinessUnitUser: "",
    callerId: "",
  });
  const [smData, setSmData] = useState(null);

  console.log("postmortemState", postmortemState);

  // ── helpers ──────────────────────────────────────────────────────────────

  /**
   * Fire a triple-beep burst (3 × 880 Hz pulses, 150 ms apart) at full volume.
   * Call startRepeatingBeep() to repeat the burst every 4 s.
   * Call stopRepeatingBeep() to silence it.
   */
  const playBeepBurst = () => {
    try {
      // Reuse the same AudioContext so closing it later stops sound immediately
      if (!audioCtxRef.current || audioCtxRef.current.state === "closed") {
        audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();
      }
      const ctx = audioCtxRef.current;
      // Three pulses: t=0, t=0.25, t=0.50
      [0, 0.25, 0.50].forEach((offset) => {
        const osc  = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = "sine";
        osc.frequency.value = 880;
        gain.gain.setValueAtTime(0,   ctx.currentTime + offset);
        gain.gain.linearRampToValueAtTime(0.4, ctx.currentTime + offset + 0.01);
        gain.gain.setValueAtTime(0.4,  ctx.currentTime + offset + 0.13);
        gain.gain.linearRampToValueAtTime(0,   ctx.currentTime + offset + 0.18);
        osc.start(ctx.currentTime + offset);
        osc.stop(ctx.currentTime  + offset + 0.2);
      });
    } catch (_) { /* AudioContext not available */ }
  };

  const startRepeatingBeep = () => {
    playBeepBurst(); // immediate first burst
    beepIntervalRef.current = setInterval(playBeepBurst, 4000);
  };

  const stopRepeatingBeep = () => {
    if (beepIntervalRef.current) {
      clearInterval(beepIntervalRef.current);
      beepIntervalRef.current = null;
    }
    // Close the AudioContext — this immediately silences any queued oscillator nodes
    if (audioCtxRef.current && audioCtxRef.current.state !== "closed") {
      audioCtxRef.current.close().catch(() => {});
      audioCtxRef.current = null;
    }
  };

  // Keep the warning flow unchanged, but silence the beep.
  const playWarningBeep = () => {};

  /** Start flashing the browser tab title */
  const startTitleFlash = (warningText) => {
    const original = document.title;
    let visible = true;
    titleFlashInterval.current = setInterval(() => {
      document.title = visible ? warningText : original;
      visible = !visible;
    }, 800);
  };

  /** Stop flashing and restore original title */
  const stopTitleFlash = () => {
    if (titleFlashInterval.current) {
      clearInterval(titleFlashInterval.current);
      titleFlashInterval.current = null;
    }
    // Restore to a sensible default; the page title will re-render normally
    document.title = "Edit Postmortem";
  };

  /** Request Notification permission once and fire a system notification */
  const fireSystemNotification = (title, body) => {
    if (!('Notification' in window)) return;
    const send = () => new Notification(title, { body, icon: "/favicon.ico" });
    if (Notification.permission === "granted") {
      send();
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((p) => { if (p === "granted") send(); });
    }
  };

  // ── Edit lock acquisition ─────────────────────────────────────────────────
  useEffect(() => {
    if (!postmortemID) return;

    // Prevents async callbacks from running after this effect is cleaned up
    // (guards against React StrictMode double-mount and navigation-before-resolve races)
    let cancelled = false;
    const acquireAbortController = new AbortController();

    const userEmail = accounts[0]?.username || "unknown";
    const userName = accounts[0]?.name || accounts[0]?.username || "unknown";

    // LOCK_DURATION_MS must match the backend (editlock.duration.minutes in application.properties)
    const LOCK_DURATION_MS = parseInt(process.env.REACT_APP_EDIT_LOCK_DURATION_MS || "120000", 10);
    const WARN_BEFORE_EXPIRY_MS = parseInt(process.env.REACT_APP_EDIT_LOCK_WARN_BEFORE_EXPIRY_MS || "30000", 10);

    const clearAllTimers = () => {
      if (editLockRefreshInterval.current) { clearInterval(editLockRefreshInterval.current); editLockRefreshInterval.current = null; }
      if (editLockWarningTimeout.current) { clearTimeout(editLockWarningTimeout.current); editLockWarningTimeout.current = null; }
      if (editLockExpiryTimeout.current) { clearTimeout(editLockExpiryTimeout.current); editLockExpiryTimeout.current = null; }
      if (editLockCountdownInterval.current) { clearInterval(editLockCountdownInterval.current); editLockCountdownInterval.current = null; }
      stopTitleFlash();
      stopRepeatingBeep();
    };

    const startExpiryCountdown = () => {
      editLockWarningTimeout.current = setTimeout(() => {
        if (cancelled) return;
        // ── Attention mechanisms ──
        setShowLockExpiryWarning(true);
        setLockExpiryCountdown(Math.round(WARN_BEFORE_EXPIRY_MS / 1000));
        playWarningBeep();
        startTitleFlash("⚠️ Edit lock expiring!");
        fireSystemNotification(
          "⚠️ Edit Lock Expiring",
          "Your postmortem edit session expires in 30 seconds. Click the tab to keep editing."
        );

        editLockCountdownInterval.current = setInterval(() => {
          setLockExpiryCountdown((prev) => {
            if (prev <= 1) {
              clearInterval(editLockCountdownInterval.current);
              editLockCountdownInterval.current = null;
              return 0;
            }
            return prev - 1;
          });
        }, 1000);

        editLockExpiryTimeout.current = setTimeout(() => {
          if (cancelled) return;
          setShowLockExpiryWarning(false);
          setEditLockStatus("expired");
          clearAllTimers();
          // Release the server lock now — don't wait for tab close/navigation.
          // Once the client timer fires the lock is logically gone; releasing here
          // keeps the DB clean and prevents tab-close/navigate from skipping the
          // release because lockAcquiredRef is already false.
          if (lockAcquiredRef.current) {
            lockAcquiredRef.current = false;
            releaseEditLock(postmortemID, userEmail).catch(
              (e) => console.error("Error releasing edit lock on expiry:", e)
            );
          }
        }, WARN_BEFORE_EXPIRY_MS);
      }, LOCK_DURATION_MS - WARN_BEFORE_EXPIRY_MS);
    };

    const initEditLock = async () => {
      try {
        const result = await acquireEditLock(postmortemID, userEmail, userName, true, acquireAbortController.signal); // isNewTab=true: increments server tabCount
        if (cancelled) return; // component unmounted while awaiting — discard result
        if (result.success) {
          lockAcquiredRef.current = true;
          setEditLockStatus("acquired");
          clearAllTimers();
          startExpiryCountdown();
        } else {
          lockAcquiredRef.current = false;
          setEditLockStatus("locked");
          setEditLockedBy(result.lockedBy || "");
          setEditLockedByName(result.lockedByName || result.lockedBy || "");
        }
      } catch (e) {
        if (cancelled) return;
        if (e?.name === 'CanceledError' || e?.name === 'AbortError') return; // aborted by cleanup
        console.error("Error acquiring edit lock:", e);
        lockAcquiredRef.current = false;
        setEditLockStatus("error");
      }
    };

    initEditLock();

    // ── beforeunload: release lock when tab/window is closed ─────────────
    // fetch with keepalive:true can send auth headers (Authorization, consumer-key) and
    // survives tab closure — sendBeacon cannot send custom headers so it fails at the
    // Maersk API gateway with 401/403.
    const handleBeforeUnload = () => {
      if (!lockAcquiredRef.current) return;
      lockAcquiredRef.current = false;
      stopRepeatingBeep();
      stopTitleFlash();
      releaseEditLockBeacon(postmortemID, userEmail);
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      cancelled = true; // stop any in-flight async callbacks from scheduling new timers
      acquireAbortController.abort(); // cancel in-flight acquire request (prevents StrictMode double-mount from hitting server twice)
      window.removeEventListener("beforeunload", handleBeforeUnload);
      clearAllTimers();
      // Only release the lock if THIS instance successfully acquired it.
      // This prevents React StrictMode's intentional double-mount from firing
      // a spurious release on the first (discarded) mount.
      // The server decrements tabCount and only truly releases when count hits 0.
      if (lockAcquiredRef.current) {
        lockAcquiredRef.current = false;
        releaseEditLock(postmortemID, userEmail).catch(
          (e) => console.error("Error releasing edit lock on unmount:", e)
        );
      }
    };
  }, [postmortemID]);

  // Called when user clicks "Keep Editing" in the warning dialog
  const extendEditLock = async () => {
    // Stop the beep and dismiss the dialog immediately — don't wait for the API call
    stopRepeatingBeep();
    stopTitleFlash();
    setShowLockExpiryWarning(false);
    if (editLockWarningTimeout.current) { clearTimeout(editLockWarningTimeout.current); editLockWarningTimeout.current = null; }
    if (editLockExpiryTimeout.current) { clearTimeout(editLockExpiryTimeout.current); editLockExpiryTimeout.current = null; }
    if (editLockCountdownInterval.current) { clearInterval(editLockCountdownInterval.current); editLockCountdownInterval.current = null; }

    const userEmail = accounts[0]?.username || "unknown";
    const userName = accounts[0]?.name || accounts[0]?.username || "unknown";
    // Use the server-provided expiry when possible so client timers match backend
    const clearAllTimers = () => {
      if (editLockRefreshInterval.current) { clearInterval(editLockRefreshInterval.current); editLockRefreshInterval.current = null; }
      if (editLockWarningTimeout.current) { clearTimeout(editLockWarningTimeout.current); editLockWarningTimeout.current = null; }
      if (editLockExpiryTimeout.current) { clearTimeout(editLockExpiryTimeout.current); editLockExpiryTimeout.current = null; }
      if (editLockCountdownInterval.current) { clearInterval(editLockCountdownInterval.current); editLockCountdownInterval.current = null; }
      stopTitleFlash();
      stopRepeatingBeep();
    };

    try {
      const result = await acquireEditLock(postmortemID, userEmail, userName, false); // isNewTab=false: refresh only, tabCount unchanged
      if (result.success) {
        lockAcquiredRef.current = true;
        setShowLockExpiryWarning(false);
        clearAllTimers();

        // Determine lock window in ms. Prefer server `expiresAt` if provided, otherwise fall back to env var.
        const now = Date.now();
        let lockMs = null;
        if (result.expiresAt) {
          const expires = Date.parse(result.expiresAt);
          if (!isNaN(expires)) {
            lockMs = Math.max(0, expires - now);
          }
        }
        if (lockMs === null) {
          lockMs = parseInt(process.env.REACT_APP_EDIT_LOCK_DURATION_MS || "120000", 10);
        }

        const WARN_BEFORE_EXPIRY_MS = parseInt(process.env.REACT_APP_EDIT_LOCK_WARN_BEFORE_EXPIRY_MS || "30000", 10);

        // If lock window is already <= warn window, show the warning immediately
        if (lockMs <= WARN_BEFORE_EXPIRY_MS) {
          setShowLockExpiryWarning(true);
          setLockExpiryCountdown(Math.round(WARN_BEFORE_EXPIRY_MS / 1000));
          playWarningBeep();
          startTitleFlash("⚠️ Edit lock expiring!");
          fireSystemNotification(
            "⚠️ Edit Lock Expiring",
            "Your postmortem edit session expires in 30 seconds. Click the tab to keep editing."
          );
          editLockCountdownInterval.current = setInterval(() => {
            setLockExpiryCountdown((prev) => {
              if (prev <= 1) { clearInterval(editLockCountdownInterval.current); editLockCountdownInterval.current = null; return 0; }
              return prev - 1;
            });
          }, 1000);
          editLockExpiryTimeout.current = setTimeout(() => {
            setShowLockExpiryWarning(false);
            setEditLockStatus("expired");
            clearAllTimers();
            if (lockAcquiredRef.current) {
              lockAcquiredRef.current = false;
              releaseEditLock(postmortemID, userEmail).catch(
                (e) => console.error("Error releasing edit lock on expiry:", e)
              );
            }
          }, WARN_BEFORE_EXPIRY_MS);
        } else {
          // Schedule the warning to appear (lockMs - warnMs) from now
          editLockWarningTimeout.current = setTimeout(() => {
            setShowLockExpiryWarning(true);
            setLockExpiryCountdown(Math.round(WARN_BEFORE_EXPIRY_MS / 1000));
            playWarningBeep();
            startTitleFlash("⚠️ Edit lock expiring!");
            fireSystemNotification(
              "⚠️ Edit Lock Expiring",
              "Your postmortem edit session expires in 30 seconds. Click the tab to keep editing."
            );
            editLockCountdownInterval.current = setInterval(() => {
              setLockExpiryCountdown((prev) => {
                if (prev <= 1) { clearInterval(editLockCountdownInterval.current); editLockCountdownInterval.current = null; return 0; }
                return prev - 1;
              });
            }, 1000);
            editLockExpiryTimeout.current = setTimeout(() => {
              setShowLockExpiryWarning(false);
              setEditLockStatus("expired");
              clearAllTimers();
              if (lockAcquiredRef.current) {
                lockAcquiredRef.current = false;
                releaseEditLock(postmortemID, userEmail).catch(
                  (e) => console.error("Error releasing edit lock on expiry:", e)
                );
              }
            }, WARN_BEFORE_EXPIRY_MS);
          }, lockMs - WARN_BEFORE_EXPIRY_MS);
        }
      }
    } catch (e) {
      console.error("Error extending edit lock:", e);
      // beep was already stopped at the top of this function
    }
  };

  // Called when user clicks "Release & Exit" — stops beep, releases lock, then navigates
  const handleReleaseLock = () => {
    stopRepeatingBeep();
    stopTitleFlash();
    setShowLockExpiryWarning(false);
    if (editLockWarningTimeout.current) { clearTimeout(editLockWarningTimeout.current); editLockWarningTimeout.current = null; }
    if (editLockExpiryTimeout.current) { clearTimeout(editLockExpiryTimeout.current); editLockExpiryTimeout.current = null; }
    if (editLockCountdownInterval.current) { clearInterval(editLockCountdownInterval.current); editLockCountdownInterval.current = null; }
    if (lockAcquiredRef.current) {
      const email = accounts[0]?.username || "unknown";
      lockAcquiredRef.current = false;
      releaseEditLock(postmortemID, email).catch(
        (e) => console.error("Error releasing edit lock on exit:", e)
      );
    }
    navigate("/ongoing-postmortems");
  };

  useEffect(() => {
    if (postmortemState.postmortemIsIncompleteState) {
      const { incomplete } = postmortemState.postmortemIsIncompleteState;
      setPostMortemIsIncomplete(incomplete);
    }
  },[postmortemState.postmortemIsIncompleteState])

  useEffect(() => {
    const fetchData = async () => {
      setLoadingData(true);
      try {
        console.log("Fetching postmortem data...", apiEndpoint);
        let data = await fetchPostmortemByIdAndCollaborators(
          apiEndpoint,
          postmortemID + '?page_type=' + pageType
        );
        if (
          data &&
          data.postmortemObject &&
          data.postmortemObject.postmortemData
        ) {
          const postmortemData = data.postmortemObject.postmortemData;
          setPostMortemIsIncomplete(
            postmortemData.postMortemIncomplete || false
          );
          setClosedWithoutLTReview(
            postmortemData.closedWithoutLTReview || false
          );
          setEdSignedOff(
            postmortemData.edSignedOff || false
          );
          setEdName(
            postmortemData.edName || ""
          );
          setVendorSignedOff(
            postmortemData.vendorSignedOff || false
          );
          setCausedByVendor(
            postmortemData.rootCause?.causedByVendor || ""
          );

          setCurrentPostmortemObject(postmortemData);
          setPostmortemObjectForAuditing(
            JSON.parse(JSON.stringify(postmortemData))
          );

          if (data.collaborators) {
            setCollaborators(data.collaborators);
          }

          if (data.postmortemTeamId) {
            setPostmortemTeamId(data.postmortemTeamId);
          }

          setMetaData({
            pmtId: postmortemData.customID || "",
            incidentID: postmortemData.incidentID || "",
            problemID: postmortemData.problemID || "",
            priority: postmortemData.priority || "",
            createdOn: postmortemData.createdOn || "",
            cmdb_ci: postmortemData.cmdb_ci || "",
            assigned_to: postmortemData.assigned_to || "",
            state: postmortemData.status || "",
            owningBusinessUnitUser: postmortemData.owningBusinessUnitUser || "",
            callerId: postmortemData.callerId || "",
            channelName: postmortemData.channelName || "",
            resolvedOn: postmortemData.resolvedOn || "",
          });
          
          // Set SM data from postmortem response (merged in backend)
          if (postmortemData.createdFromStabilityMonitoring) {
            setSmData({
              createdFromStabilityMonitoring: postmortemData.createdFromStabilityMonitoring,
              isResolved: postmortemData.isResolved,
              createdFromStabilityMonitoringTimestamp: postmortemData.createdFromStabilityMonitoringTimestamp,
              isResolvedTimestamp: postmortemData.isResolvedTimestamp
            });
          }
        } else {
          console.error("Invalid data structure:", data);
        }
        const newPage = location.pathname;
        const newSteps = getTourSteps(newPage);
        if (typeof setCurrentTouringSteps === "function") {
          setCurrentTouringSteps(newSteps);
        }
      } catch (error) {
        console.error("Error setting postmortem data:", error);
        setError(error);
      } finally {
        setLoadingData(false);
      }
    };
    fetchData();
  }, [setCurrentTouringSteps]);

  // const { data, error, isLoading, refetch } = useQuery(
  //   ["postmortemDataForAPostmortem", pmtId],
  //   () => fetchPostmortemByIdAndCollaborators(apiEndpoint, pmtId),
  //   {
  //     refetchOnWindowFocus: false,
  //     onSuccess: (data) => {

  //       setCurrenPostmortemObject(data.postmortemObject);
  //       setCollaborators(data.collaborators);
  //       setPostmortemTeamId(data.postmortemTeamId);
  //     },
  //     // Add other query options as needed
  //   }
  // );

  useEffect(() => {
    const currentState = postmortemState?.postmortemCurrentStatus?.currentState;
    if (!currentState) return;
    const isP3orP4 = metaData.priority === "3" || metaData.priority === "4";
    switch (currentState) {
      case "DRAFT":
      case "DRAFT":
        setCurrentStep(0);
        break;
      case "LEADERSHIP_REVIEW":
        setCurrentStep(1);
        break;
      case "DONE":
        setCurrentStep(isP3orP4 ? 3 : 4);
        break;
      default:
        setCurrentStep(0);
    }
  }, [postmortemState?.postmortemCurrentStatus?.currentState, metaData.priority]);

  // Keep metaData.state in sync with context so the STATE badge updates without a refresh
  useEffect(() => {
    const currentState = postmortemState?.postmortemCurrentStatus?.currentState;
    if (currentState) {
      setMetaData((prev) => ({ ...prev, state: currentState }));
    }
  }, [postmortemState?.postmortemCurrentStatus?.currentState]);

  // Update causedByVendor state when RootCauseState changes
  useEffect(() => {
    if (postmortemState && postmortemState.RootCauseState && postmortemState.RootCauseState.causedByVendor) {
      setCausedByVendor(postmortemState.RootCauseState.causedByVendor);
    }
  }, [postmortemState.RootCauseState?.causedByVendor]);

  const navigate = useNavigate();

  const navigateTo = (path) => {
    navigate(path.path);
  };

  const MarkThisPostmortemInComplete = async () => {
    if (!userIsAdmin) {
      return;
    }
    const {
      postmortemIsIncompleteState: { incomplete },
    } = postmortemState;

    let state = !incomplete
      ? { 
          postMortemIncomplete: true,
          incompleteMarkedBy: graphData?.username || "",
          incompleteMarkedAt: new Date().toISOString()
        }
      : { postMortemIncomplete: false };

    try {
      // WebSocket disabled - broadCastIncompleteStatus feature commented out
      // if (broadCastIncompleteStatus) {
      //   broadCastIncompleteStatus(postmortemID, state.postMortemIncomplete);
      // }
      await updateIncompleteStatus(apiEndpoint, incidentID, state);


      let auditData = {
        changedFeilds:[
          "postMortemIncomplete",
          ...(state.incompleteMarkedAt ? ["incompleteMarkedAt"] : [])
        ],
        changedData: {
          postMortemIncomplete: state.postMortemIncomplete,
          ...(state.incompleteMarkedAt && { incompleteMarkedAt: state.incompleteMarkedAt }),
          incidentId: incidentID,
          postmortemId: postmortemID,
        },

        updatedBy: graphData?.username || "",
  

      }
      await postAuditData(
        postmortemApiEndpoint,
        auditData
      );
 
      // Refresh the postmortem data to reflect the updated incompleteMarkedBy
      const data = await fetchPostmortemByIdAndCollaborators(
        apiEndpoint,
        postmortemID + '?page_type=' + pageType
      );
      if (data && data.postmortemObject && data.postmortemObject.postmortemData) {
        const postmortemData = data.postmortemObject.postmortemData;
        setCurrentPostmortemObject(postmortemData);
        setPostMortemIsIncomplete(postmortemData.postMortemIncomplete || false);
      }

      successNotification("Status Updated Successfully");
      memoizedDispatch({
        type: "HANDLE EDITOR CHANGE",
        field: "postmortemIsIncompleteState",
        payload: { incomplete: !incomplete },
      });
    } catch (error) {
      if (error.response?.status === 401) sessionStorage.clear();
      errorNotification("Error Updating Status, Please Contact SRE");
      console.log(error);
      throw error;
    }
  };

  const HandleCloseWithoutLTReview = async () => {
    if (!userIsAdmin) {
      return;
    }
    
    // Prevent if postmortem is marked as incomplete (mutually exclusive)
    if (!closedWithoutLTReview && postmortemIsInComplete) {
      errorNotification("Cannot mark as 'Close without TLT Review' while postmortem is marked as Incomplete. Please unmark Incomplete first.");
      return;
    }

    const newStatus = !closedWithoutLTReview;
    let state = {
      closedWithoutLTReview: newStatus,
      closedWithoutLTReviewBy: newStatus ? (graphData?.username || "") : null,
      closedWithoutLTReviewAt: newStatus ? new Date().toISOString() : null
    };

    try {
      await updateClosedWithoutLTReviewStatus(apiEndpoint, incidentID, state);

      let auditData = {
        changedFeilds: [
          "closedWithoutLTReview",
          ...(state.closedWithoutLTReviewAt ? ["closedWithoutLTReviewAt"] : [])
        ],
        changedData: {
          closedWithoutLTReview: state.closedWithoutLTReview,
          ...(state.closedWithoutLTReviewAt && { closedWithoutLTReviewAt: state.closedWithoutLTReviewAt }),
          incidentId: incidentID,
          postmortemId: postmortemID,
        },
        updatedBy: graphData?.username || "",
      };
      
      await postAuditData(postmortemApiEndpoint, auditData);

      // Refresh the postmortem data to reflect the status change
      const data = await fetchPostmortemByIdAndCollaborators(
        apiEndpoint,
        postmortemID + '?page_type=' + pageType
      );
      if (data && data.postmortemObject && data.postmortemObject.postmortemData) {
        const postmortemData = data.postmortemObject.postmortemData;
        setCurrentPostmortemObject(postmortemData);
        setClosedWithoutLTReview(postmortemData.closedWithoutLTReview || false);
        setMetaData({
          pmtId: postmortemData.customID || "",
          incidentID: postmortemData.incidentID || "",
          problemID: postmortemData.problemID || "",
          priority: postmortemData.priority || "",
          createdOn: postmortemData.createdOn || "",
          cmdb_ci: postmortemData.cmdb_ci || "",
          assigned_to: postmortemData.assigned_to || "",
          state: postmortemData.status || "",
          owningBusinessUnitUser: postmortemData.owningBusinessUnitUser || "",
          callerId: postmortemData.callerId || "",
          channelName: postmortemData.channelName || "",
        });
      }

      successNotification(newStatus ? "Postmortem marked as closed without TLT review" : "Postmortem unmarked from closed without TLT review");
    } catch (error) {
      console.error(error);
      errorNotification("Failed to update status");
    }
  };

  const HandleEDSignOff = async () => {
    const newStatus = !edSignedOff;
    
    // If checking the box, validate ED name is provided
    if (newStatus && (!edName || edName.trim() === "")) {
      errorNotification("ED Name is required for sign-off acknowledgment");
      return;
    }
    
    let signOffData = {
      edSignedOff: newStatus,
      edName: newStatus ? edName.trim() : null,
      edSignedOffBy: newStatus ? (graphData?.username || "") : null,
      edSignedOffAt: newStatus ? new Date().toISOString() : null,
      vendorSignedOff: vendorSignedOff, // Preserve existing Vendor state
      vendorSignedOffBy: vendorSignedOff ? (currentPostmortemObject?.vendorSignedOffBy || null) : null,
      vendorSignedOffAt: vendorSignedOff ? (currentPostmortemObject?.vendorSignedOffAt || null) : null
    };

    try {
      await updateEDSignOffStatus(apiEndpoint, incidentID, signOffData);

      let auditData = {
        changedFeilds: ["edSignedOff", "edName", "edSignedOffBy", "edSignedOffAt"],
        changedData: {
          edSignedOff: signOffData.edSignedOff,
          edName: signOffData.edName,
          edSignedOffBy: signOffData.edSignedOffBy,
          edSignedOffAt: signOffData.edSignedOffAt,
          incidentId: incidentID,
          postmortemId: postmortemID,
        },
        updatedBy: graphData?.username || "",
      };
      
      await postAuditData(postmortemApiEndpoint, auditData);

      // Refresh the postmortem data
      const data = await fetchPostmortemByIdAndCollaborators(
        apiEndpoint,
        postmortemID + '?page_type=' + pageType
      );
      if (data && data.postmortemObject && data.postmortemObject.postmortemData) {
        const postmortemData = data.postmortemObject.postmortemData;
        setCurrentPostmortemObject(postmortemData);
        setEdSignedOff(postmortemData.edSignedOff || false);
        setEdName(postmortemData.edName || "");
        setVendorSignedOff(postmortemData.vendorSignedOff || false);
      }

      successNotification(newStatus ? "ED sign-off acknowledged" : "ED sign-off revoked");
    } catch (error) {
      console.error(error);
      errorNotification("Failed to update ED sign-off");
    }
  };

  const HandleVendorSignOff = async () => {
    if (!userIsAdmin) {
      errorNotification("Only admin users can acknowledge vendor sign-off");
      return;
    }

    const newStatus = !vendorSignedOff;
    let signOffData = {
      edSignedOff: edSignedOff, // Preserve existing ED state
      edName: edSignedOff ? (currentPostmortemObject?.edName || null) : null,
      edSignedOffBy: edSignedOff ? (currentPostmortemObject?.edSignedOffBy || null) : null,
      edSignedOffAt: edSignedOff ? (currentPostmortemObject?.edSignedOffAt || null) : null,
      vendorSignedOff: newStatus,
      vendorSignedOffBy: newStatus ? (graphData?.username || "") : null,
      vendorSignedOffAt: newStatus ? new Date().toISOString() : null
    };

    try {
      await updateEDSignOffStatus(apiEndpoint, incidentID, signOffData);

      let auditData = {
        changedFeilds: ["vendorSignedOff", "vendorSignedOffBy", "vendorSignedOffAt"],
        changedData: {
          vendorSignedOff: signOffData.vendorSignedOff,
          vendorSignedOffBy: signOffData.vendorSignedOffBy,
          vendorSignedOffAt: signOffData.vendorSignedOffAt,
          incidentId: incidentID,
          postmortemId: postmortemID,
        },
        updatedBy: graphData?.username || "",
      };
      
      await postAuditData(postmortemApiEndpoint, auditData);

      // Refresh the postmortem data
      const data = await fetchPostmortemByIdAndCollaborators(
        apiEndpoint,
        postmortemID + '?page_type=' + pageType
      );
      if (data && data.postmortemObject && data.postmortemObject.postmortemData) {
        const postmortemData = data.postmortemObject.postmortemData;
        setCurrentPostmortemObject(postmortemData);
        setEdSignedOff(postmortemData.edSignedOff || false);
        setEdName(postmortemData.edName || "");
        setVendorSignedOff(postmortemData.vendorSignedOff || false);
        setCausedByVendor(postmortemData.rootCause?.causedByVendor || "");
      }

      successNotification(newStatus ? "Vendor acknowledgment confirmed" : "Vendor acknowledgment revoked");
    } catch (error) {
      console.error(error);
      errorNotification("Failed to update vendor acknowledgment");
    }
  };

  const handleGenerateRCAOnDemand = async () => {
    // Validate that postmortem is in NEW state
    if (postmortemState?.postmortemCurrentStatus?.currentState !== "DRAFT") {
      errorNotification("RCA generation is only available for postmortems in NEW state");
      return;
    }

    const userEmail = accounts[0]?.username || 'unknown';
    
    try {
      setGeneratingRCA(true);
      await generateRCAOnDemand(incidentID, userEmail);
      successNotification("AI RCA generation started! Please wait while we generate the draft...");
      pollForRCACompletion();
    } catch (error) {
      console.error("Error generating RCA on demand:", error);
      if (!error.message?.includes("already in progress")) {
        errorNotification(error.message || "Failed to initiate RCA generation. Please try again.");
      }
      setGeneratingRCA(false);
    }
  };

  const pollForRCACompletion = () => {
    const maxAttempts = 60; // 60 * 5s = 5 minutes max
    let attempts = 0;
    const freeTextApiBase = process.env.REACT_APP_FREE_TEXT_API_ENDPOINT;

    if (rcaPollingIntervalRef.current) {
      clearInterval(rcaPollingIntervalRef.current);
    }

    rcaPollingIntervalRef.current = setInterval(async () => {
      attempts++;

      try {
        // Poll the dedicated status endpoint — directly reflects backend in-progress state
        const status = await fetchWithRetry(
          `${freeTextApiBase}/api/postmortem/${incidentID}/rca-generation-status`,
          "pollRcaStatus"
        );

        if (status) {

          if (!status.inProgress) {
            // Backend finished — clear interval, re-enable button, show success
            clearInterval(rcaPollingIntervalRef.current);
            rcaPollingIntervalRef.current = null;
            // The backend wrote the draft asynchronously, so drop cached reads taken while it was running.
            invalidateCachedReads();
            setGeneratingRCA(false);
            successNotification("AI RCA draft generated successfully!");
          }
        }
      } catch (error) {
        console.error("Error polling RCA status:", error);
        // Continue polling even if one request fails
      }

      if (attempts >= maxAttempts) {
        clearInterval(rcaPollingIntervalRef.current);
        rcaPollingIntervalRef.current = null;
        setGeneratingRCA(false);
        errorNotification("RCA generation is taking longer than expected. Please refresh the page.");
      }
    }, 5000);
  };

  const {
    pmtId,
    incidentID,
    problemID,
    priority,
    createdOn,
    cmdb_ci,
    assigned_to,
    state,
    owningBusinessUnitUser,
    callerId,
    channelName
  } = metaData;
  
  // Check if RCA generation is available (only for NEW state postmortems)
  const canGenerateRCA = postmortemState?.postmortemCurrentStatus?.currentState === "DRAFT";
  
  const currentState = postmortemState?.postmortemCurrentStatus?.currentState;
  
  // ED sign-off is always shown at PLATFORMREVIEW_PENDING and beyond
  const showEDSignOff = edSignedOff || 
    currentState === "LEADERSHIP_REVIEW" || 
currentState === "DONE";
  
  // Vendor acknowledgment only shows when causedByVendor = "Yes"
  const showVendorSignOff = (causedByVendor === "Yes") && 
(vendorSignedOff || currentState === "LEADERSHIP_REVIEW" || currentState === "DONE");

  return {
    currentStep,
    pmtId,
    incidentID,
    problemID,
    priority,
    createdOn,
    cmdb_ci,
    assigned_to,
    state,
    navigateTo,
    loadingData,
    userIsAdmin,
    userAccessData,
    error,
    owningBusinessUnitUser,
    steps,
    setSteps,
    mimStateRef,
    MarkThisPostmortemInComplete,
    HandleCloseWithoutLTReview,
    HandleEDSignOff,
    HandleVendorSignOff,
    userIsAMimMember,
    callerId,
    postmortemIsInComplete,
    closedWithoutLTReview,
    edSignedOff,
    vendorSignedOff,
    causedByVendor,
    edName: currentPostmortemObject?.edName || null,
    edSignedOffBy: currentPostmortemObject?.edSignedOffBy || null,
    vendorSignedOffBy: currentPostmortemObject?.vendorSignedOffBy || null,
    closedWithoutLTReviewBy: currentPostmortemObject?.closedWithoutLTReviewBy || null,
    incompleteMarkedBy: currentPostmortemObject?.incompleteMarkedBy || null,
    channelName,
    userIsApmtMember,
    smData,
    handleGenerateRCAOnDemand,
    generatingRCA,
    canGenerateRCA,
    showEDSignOff,
    showVendorSignOff,
    edName,
    setEdName,
    editLockStatus,
    editLockedBy,
    editLockedByName,
    showLockExpiryWarning,
    lockExpiryCountdown,
    extendEditLock,
    handleReleaseLock,
    setCurrentPostmortemObject,
    currentPostmortemObject,
  };
};
